module.exports = __webpack_public_path__ + "static/media/favorite-icon.fd41e7d3.svg";